<!--
 @description 服务监控-应用性能-主机tab
 @author xiehan
 @date 2018/11/13
-->
<template>
  <div>
    <div style="margin-bottom: 10px;">
      <el-button type="primary" @click="getHostTime(1)" v-g-rac="gRac('appDetailHost_search')" v-text="$t('serverMonitor.today')"></el-button>
      <el-button type="primary" @click="getHostTime(1800000)" v-g-rac="gRac('appDetailHost_search')" v-text="$t('serverMonitor.thirtyMins')"></el-button>
      <el-button type="primary" @click="getHostTime(3600000)" v-g-rac="gRac('appDetailHost_search')" v-text="$t('serverMonitor.oneHour')"></el-button>
      <el-button type="primary" @click="getHostTime(10800000)" v-g-rac="gRac('appDetailHost_search')" v-text="$t('serverMonitor.threeHours')"></el-button>
      <el-button type="primary" @click="getHostTime(21600000)" v-g-rac="gRac('appDetailHost_search')" v-text="$t('serverMonitor.sixHours')"></el-button>
      <el-button type="primary" @click="getHostTime(43200000)" v-g-rac="gRac('appDetailHost_search')" v-text="$t('serverMonitor.twelveHours')"></el-button>
      <el-button type="primary" @click="getHostTime(2)" v-g-rac="gRac('appDetailHost_search')" v-text="$t('serverMonitor.yesterday')"></el-button>
    </div>
    <el-form ref="chartForm" :model="chartForm" label-width="40px" :inline="true" class="demo-form-inline">
      <el-form-item :label="$t('common.time')" input-width="auto">
        <el-form-item prop="startTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="chartForm.startTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <span v-text="$t('common.to')"></span>
        <el-form-item prop="endTime" style="margin-left: 10px">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="chartForm.endTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('serverMonitor.hostIP')" prop="ip" label-width="60px">
          <g-select v-model="chartForm.ip" :list="select_ip"></g-select>
        </el-form-item>
        <el-form-item input-width="80px">
          <el-button type="primary" @click="getKpiMapping" v-g-rac="gRac('appDetailHost_search')" v-text="$t('common.search')"></el-button>
        </el-form-item>
      </el-form-item>
    </el-form>
    <chart-list v-show="this.chartDataList.length > 0" :chart-data-list="chartDataList"></chart-list>
    <div v-show="this.chartDataList.length === 0" v-text="$t('common.noData')" style="text-align: center"></div>
  </div>
</template>
  
<script>
  import chartList from '@/components/chart/chart-config-list'
  
  import rac from '@/plugins/rac-mixin'
  import KpiMappingBiz from '@/logic/systemSetting/kpiMappingBiz'
  import hostMappingBiz from '@/logic/intelligentMonitor/hostMappingBiz'
  import CmdbBiz from '@/logic/cmdb/cmdbBiz'
  export default {
    mixins: [rac],
    data () {
      return {
        chartForm: {
          startTime: '',
          endTime: '',
          ip: ''
        },
        select_ip: {},
        chartDataList: [],
        prevReset: ''
      }
    },
    components: {
      chartList
    },
    props: ['app', 'group', 'ip', 'port', 'reset', 'active'],
    methods: {
      getHostTime (time) {
        if (Number(time) === 1) {
          this.chartForm.startTime = new Date(new Date().toLocaleDateString()).getTime()
          this.chartForm.endTime = new Date().getTime()
        } else if (Number(time) === 2) {
          this.chartForm.startTime = new Date(new Date().toLocaleDateString()).getTime() - 86400000
          this.chartForm.endTime = new Date(new Date().toLocaleDateString()).getTime()
        } else {
          this.chartForm.startTime = new Date().getTime() - Number(time)
          this.chartForm.endTime = new Date().getTime()
        }
        this.getKpiMapping()
      },
      getIpList () {
        CmdbBiz.ipList({ groups: this.group, applications: this.app }).then(res => {
          let ipObj = {}
          res.map(item => {
            if (item) ipObj[item] = item
          })
          this.select_ip = ipObj
          this.chartForm.ip = this.ip
          this.getKpiMapping()
        })
      },
      getKpiMapping () {
        KpiMappingBiz.getKpiMap({ group: 'HOST', appName: 'hostperf', siteCode: this.$route.query.siteCode }).then(data => {
          let promiseList = []
          let promiseRes = []
          data.map(item => {
            let alarm = !!item.alarm
            promiseList.push(this.getChartData(item.kpiKey, item.desc, alarm, item.fields[0]))
          })
          Promise.all(promiseList).then((res) => {
            res.map(_item => {
              promiseRes.push(_item)
            })
            this.drawChart(promiseRes)
          })
        })
      },
      getChartData (kpiKey, desc, alarm, fields) {
        return new Promise((resolve, reject) => {
          hostMappingBiz.searchChartData({
            appName: 'hostperf',
            ip: this.chartForm.ip ? this.chartForm.ip : '',
            siteCode: this.$route.query.siteCode,
            kpiKey: kpiKey,
            startTime: this.chartForm.startTime,
            endTime: this.chartForm.endTime ? this.chartForm.endTime : new Date().getTime()
          }).then(data => {
            resolve({
              title: desc,
              data: data.performs ? data.performs : [],
              alarm: alarm,
              fields: fields,
              kpiInfo: {
                appGroup: 'HOST',
                appName: 'hostperf',
                kpiKey: kpiKey,
                siteCode: this.$route.query.siteCode
              }
            })
          }).catch(err => {
            reject(err)
          })
        })
      },
      drawChart (dataList) {
        const list = []
        dataList.map((item, index) => {
          const chartData = {
            title: item.title,
            kpiInfo: item.kpiInfo,
            chartId: `chartGroups-serverHOST-${item.title}${index}`,
            chartData: {
              rows: item.data ? item.data : [],
              columns: [item.fields.xName, item.fields.yName],
              formatMap: {
                [item.fields.xName]: 'TIME',
                [item.fields.yName]: item.fields.format
              },
              alarm: item.alarm,
              labelMap: {
                value: item.title
              }
            }
          }
          list.push(chartData)
        })
        this.chartDataList = list
      }
    },
    watch: {
      active (val) {
        if (this.active === 'host' && this.prevReset !== this.reset) {
          this.chartForm.startTime = new Date(new Date().toLocaleDateString()).getTime()
          this.chartForm.endTime = ''
          this.getIpList()
          this.prevReset = this.reset
        }
      }
    }
  }
</script>

<style>

</style>